import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// language files
import en from '@/lang/translations/en';
import de from '@/lang/translations/de';
import cn from '@/lang/translations/cn';

const lang = localStorage.getItem('language');
const locale = lang ? lang : 'en';

const messages = {
    en,
    de,
    'zh-cn': cn
};

export default new VueI18n({
    locale: locale, // set locale
    fallbackLocale: 'en', // set fallback locale
    messages // set locale messages
});
